/**
 * Shared pieces of a log file transfer, so every caller asks for a tail the
 * same way and the rule stays testable without a network.
 */

/**
 * Path of one log file on the node, relative to its API root. The component
 * segment picks the directory: the same file name exists in more than one.
 */
export function logFilePath(component: string, name: string): string {
    return `/api/v1/logs/files/${encodeURIComponent(component)}/${encodeURIComponent(name)}`;
}

/**
 * Builds the Range header that fetches only a file's last `tailBytes`. The
 * suffix form is what lets the viewer open a large live log at its newest end
 * without knowing where the last rotation left the file's length.
 */
export function logFileRange(tailBytes?: number): string | undefined {
    if (!tailBytes || !Number.isFinite(tailBytes) || tailBytes <= 0) {
        return undefined;
    }
    return `bytes=-${Math.floor(tailBytes)}`;
}

/**
 * Drops a leading partial line from a tail transfer. A suffix range cuts the
 * file at an arbitrary byte, so the first line is usually a fragment that
 * would otherwise parse as a continuation of nothing.
 */
export function dropLeadingFragment(text: string): string {
    const firstBreak = text.indexOf('\n');
    // No break at all means the transfer never reached a line boundary, so every
    // byte of it belongs to a line whose beginning was not fetched.
    return firstBreak === -1 ? '' : text.slice(firstBreak + 1);
}
